export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create a widget for"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generate"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payment in"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amount of payment"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions on Success"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions on failure"])}
}